import './Tabs.scss';

type TabsType = {
  setCurrentTab: (number) => void;
  currentTab: { name: string; index: number };
  data: any;
  secondAction?: () => void;
  isDark?: boolean;
};

const Tabs = ({ setCurrentTab, currentTab, data, secondAction }: TabsType) => {
  return (
    <div className="tabs">
      <ul className="tabs__container">
        {data?.map((item, index) => (
          <li
            key={index}
            className={`${currentTab.index === index ? 'tabs__item--active' : 'tabs__item'} ${
              item.nombre === 'Mis datos'
                ? 'gtmHomePersonasClicPagosMisDatos'
                : 'gtmHomePersonasClicPagosMiGrupoFamiliar'
            }`}
            onClick={() => {
              setCurrentTab({ name: item?.nombre, index });
              secondAction && secondAction();
            }}
          >
            {item.imagen && (
              <img
                src={
                  item.imagen[currentTab.index === index ? 1 : 0]?.file?.url ||
                  item.imagen[currentTab.index === index ? 1 : 0]?.url
                }
                aria-hidden={item.imagen[currentTab.index === index ? 1 : 0].title}
                alt={item.nombre + index}
                loading="lazy"
              />
            )}
            <p>{item.nombre}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Tabs;
